
/*****************************************/
/************* MODEL CLASSES *************/
/*****************************************/

class TyreDetailLineModel {
	constructor() {
		this.wheelSelected = null;
		this.width = null;
		this.ratio = null;
		this.diameter = null;
		this.rating = null;
		this.load = null;
		this.construction = null;
		this.brand = null;
		this.title = null;
		this.damageType = null;
		this.pattern = null;
	}

	static getTyreBrands(callback) {
		$.get('/Tyres/GetAllTyreBrands').done(function (data) {
			callback(data);
		});
	};
};

class VehicleDetails {
	constructor(mileage, reg, id, make, model, orderNumber, mileageCheckSuppression) {
		this.vehicleMileage = mileage;
		this.vehicleId = id;
		this.vehicleReg = reg;
		this.vehicleMake = make;
		this.vehicleModel = model;
        this.orderNumber = orderNumber;
        this.mileageCheckSuppression = mileageCheckSuppression
	}
};

class VehicleClassWheelPlan {

	constructor(className, wheelPlans) {
		this.name = className;
		this.wheelPlans = wheelPlans;
	}

	get wheelPlans() {
		return this._wheelPlans;
	}
	set wheelPlans(wheelPlan) {
		this._wheelPlans = wheelPlan;
	}

	get plans() {
		return this._plans;
	}
	set plans(wheelPlan) {
		this._plans = wheelPlan;
	}

	GetWheelPlans(className) {
		//populate wheel plan.
		return this.wheelplans.filter((plan) => {
			return plan.className == className;
		});
	};

	GetWheelPlanImageName(className, id) {
		return this._wheelPlans.find(plan => plan.id === id).image;
	}
};

class VehicleDataModel {
	constructor () {
		this._wheelPlan = null;
		this._wheelDetails = null;
		this._vehicleDetails = null;
		this._tyreDetailLines = [];
		this._wheelsSelected = null;
		this._tyreHistory = null;
		this._class = null;
	}

	get tyreDetailLines() {
		return this._tyreDetailLines;
	}
	set tyreDetailLines(newDetails) {
		this._tyreDetailLines = newDetails;
	}

	get wheelPlan() {
		return this._wheelPlan;
	}
	set wheelPlan(newPlan) {
		this._wheelPlan = newPlan;
	}

	get vehicleDetails() {
		return this._vehicleDetails;
	}
	set vehicleDetails(newDetails) {
		this._vehicleDetails = newDetails;
	}

	get wheelDetails() {
		return this._wheelDetails;
	}
	set wheelDetails(newDetails) {
		this._wheelDetails = newDetails;
	}

	get wheelSelected() {
		return this._wheelsSelected;
	}
	set wheelSelected(newSelection) {
		this._wheelsSelected = newSelection;
	}

	get tyreHistory() {
		return this._tyreHistory;
	}
	set tyreHistory(newHistory) {
		this._tyreHistory = newHistory;
	}

	get class() {
		return this._class;
	}

	set class(newClass) {
		this._class = newClass;
	}

};

class CustomerModel {
	constructor	(name, homeLink) {
		this._name = name;
		this._homeLink = homeLink;
	}

	get name () {
		return this._name;
	}

	get homeLink () {
		return this._homeLink;
	}

}

class DataModel {
	constructor() {

		this._vehicle = new VehicleDataModel();

		this._driver = null;

		this._bookingDetails = new BookingDetailsModel();

		this.selectedDepot = null;

		this.customer = null;
	}

	get driver() {
		return this._driver;
	}
	set driver(newDriver) {
		this._driver = newDriver;
	}

	get vehicle () {
		return this._vehicle;
	}
	set vehicle (newVehicle) {
		this._vehicle  = newVehicle;
	}

	get bookingDetails() {
		return this._bookingDetails;
	}
	set bookingDetails(newDetails) {
		this._bookingDetails = newDetails;
	}

	// builds an object for development to allow skipping steps when testing
	initSelfDevObject(constructedObject) {
		this.driver = constructedObject.driver;
		this.vehicle = constructedObject.vehicle;
		this.bookingDetails = constructedObject.bookingDetails;
	};
};

class CalendarHelpers {
	static getUnavailableBookingDates(callback) {
	let nonBookingDates = [];

		$.get('/Tyres/GetUnavailableBookingCalendarDates', function (data) {
			if (data !== undefined && data.length > 0) {
				$.each(data, function (_index, date) {
					nonBookingDates.push(new Date(Date.parse(date)));
				});
			}
		}).done(function () { callback(nonBookingDates); });
	};

	static getFirstAvailableDateTime() {
		return new Promise((resolve, reject) => {
			$.get('/Tyres/GetFirstAvailableDateTime')
				.done(data => resolve(data))
				.fail(error => reject(error));
		});
	};
};

class WheelDetailsModel {
	constructor(wheelType, roadworthySpare, spareSize, inflationKit, lockingWheelNuts, obstruction, obstructionDetails) {
		this.wheelType = wheelType;
		this.obstructions = obstruction;
		this.roadworthySpare = roadworthySpare;
		this.spareSize = spareSize;
		this.inflationKit = inflationKit;
		this.lockingWheelNuts = lockingWheelNuts;
		this.obstructionDetails = obstructionDetails;
	}
}

class DriverModel {
	constructor(title, firstname, lastname, mobile, landline, email, smsConfirmation, address, privacyPolicyAccepted, additionalInformation) {
		this.title = title;
		this.firstname = firstname;
		this.surname = lastname;
		this.mobile = mobile;
		this.landline = landline;
		this.email = email;
		this.smsConfirmation = smsConfirmation;
		this.address = address;
		this.privacyPolicyAccepted = privacyPolicyAccepted;
		this.additionalInformation = additionalInformation
	}
};

class AddressModel {
	constructor(name, line1, line2, town, county, postcode) {
		this.name = name;
		this.line1 = line1;
		this.line2 = line2;
		this.town = town;
		this.county = county;
		this.postcode = postcode;
	}
};

class BookingDetailsModel {
	constructor () {
		this._serviceRequired = null;
		this._location = new AddressModel();
		this._bookingDate = null;
		this._bookingTime = null;
		this._bookingDate2 = null;
		this._bookingTime2 = null;
		this._bookingDate3 = null;
		this._bookingTime3 = null;
		this._depot = null;
		this._addressType = null;
		this._jobType = null;
		this._jobTypeName = null;
	}

	get bookingDate () {
		return this._bookingDate;
	}
	set bookingDate(newDate) {
		this._bookingDate = newDate;
	}

	get bookingTime() {
		return this._bookingTime;
	}
	set bookingTime(newTime) {
		this._bookingTime = newTime;
	}

	get bookingDate2() {
		return this._bookingDate2;
	}
	set bookingDate2(newDate) {
		this._bookingDate2 = newDate;
	}

	get bookingTime2() {
		return this._bookingTime2;
	}
	set bookingTime2(newTime) {
		this._bookingTime2 = newTime;
	}

	get bookingDate3() {
		return this._bookingDate3;
	}
	set bookingDate3(newDate) {
		this._bookingDate3 = newDate;
	}

	get bookingTime3() {
		return this._bookingTime3;
	}
	set bookingTime3(newTime) {
		this._bookingTime3 = newTime;
	}

	get serviceRequired () {
		return this._serviceRequired;
	}
	set serviceRequired (newService) {
		this._serviceRequired = newService;
	}

	get location () {
		return this._location;
	}
	set location(newLocation) {
		this._location = newLocation;
	}

	get depot () {
		return this._depot;
	}
	set depot (newDepot) {
		this._depot = newDepot;
	}

	get addressType() {
		return this._addressType;
	}
	set addressType(addressTypeValue) {
		this._addressType = addressTypeValue;
	}

	get jobType() {
		return this._jobType;
	}
	set jobType(jobTypeValue) {
		this._jobType = jobTypeValue;
	}

	get jobTypeName() {
		return this._jobTypeName;
	}
	set jobTypeName(jobTypeNameValue) {
		this._jobTypeName = jobTypeNameValue;
	}
};

class TyreCriteriaAttribute {
	constructor	(name, value, position) {
		this.name = name;
		this.value = value;
		this.position = position;
		this.selected = false;
	}
}

class Enums {
	static timesSaturday = [
		{
			id: 0,
			value: "Please Select"
		},
		{
			id: 9,
			value: "09:00AM"
		},
		{
			id: 10,
			value: "10:00AM"
		},
		{
			id: 11,
			value: "11:00AM"
		},
		{
			id: 12,
			value: "12:00PM"
		}];

	static timesWeekday = [
		{
			id: 0,
			value: "Please Select"
		},
		{
			id: 9,
			value: "09:00AM"
		},
		{
			id: 10,
			value: "10:00AM"
		},
		{
			id: 11,
			value: "11:00AM"
		},
		{
			id: 12,
			value: "12:00PM"
		},
		{
			id: 13,
			value: "01:00PM"
		},
		{
			id: 14,
			value: "02:00PM"
		},
		{
			id: 15,
			value: "03:00PM"
		},
		{
			id: 16,
			value: "04:00PM"
		}];
}

/*****************************************/
/************ GLOBAL VARIABLES ***********/
/*****************************************/

let _data = new DataModel();
let _tyresSpecs = {
	collection: [
		{
			moniker: 'NSF',
			name: 'Passenger Side Front'
		},
		{
			moniker: 'OSF',
			name: 'Driver Side Front'
		},
		{
			moniker: 'NSR',
			name: 'Passenger Side Rear'
		},
		{
			moniker: 'OSR',
			name: 'Driver Side Rear'
		},
		{
			moniker: 'NSR2',
			name: 'Passenger Side Rear Outside'
		},
		{
			moniker: 'OSR2',
			name: 'Driver Side Rear Outside'
		},
		{
			moniker: 'SPARE',
			name: 'Spare'
		}
	],
	getName(moniker) {
		return this.collection.find(tyre => tyre.moniker === moniker).name
	}
};

/*****************************************/
/*************** EXPORTS *****************/
/*****************************************/

export {
	_data,
	_tyresSpecs,
	TyreDetailLineModel,
	WheelDetailsModel,
	DriverModel,
	AddressModel,
	BookingDetailsModel,
	CalendarHelpers,
	VehicleDetails,
	TyreCriteriaAttribute,
	VehicleClassWheelPlan,
	CustomerModel,
	VehicleDataModel,
	Enums
};
